export type Language = 'en' | 'ar'

export const translations = {
  en: {
    // Navigation
    'nav.platform': 'Platform',
    'nav.pricing': 'Pricing',
    'nav.testimonials': 'Testimonials',
    'nav.faq': 'FAQ',
    'nav.login': 'Log in',
    'nav.getStarted': 'Get Started Free',

    // Hero
    'hero.badge': 'Enterprise ERP Platform',
    'hero.headline': 'Your Entire Business.',
    'hero.headlineGold': 'One Platform.',
    'hero.description': 'Enterprise software built to unify your business. From customer relationships to finance, operations, and beyond - all on one intelligent platform.',
    'hero.cta': 'Start free Trial',
    'hero.demoLink': 'Watch Demo',
    'hero.trust1': 'SOC 2 Type II Certified',
    'hero.trust2': '4.9 / 5 on G2',
    'hero.trust3': '500+ Enterprise Clients',
    'hero.stat1': '12',
    'hero.stat1Label': 'ERP Modules',
    'hero.stat2': '99.9%',
    'hero.stat2Label': 'Uptime SLA',
    'hero.stat3': '24/7',
    'hero.stat3Label': 'Support',
    'hero.stat4': '<48h',
    'hero.stat4Label': 'Onboarding',

    // Signup
    'signup.badge': 'Get Started',
    'signup.headline': 'Ready to Transform Your Business?',
    'signup.headlineGold': 'Start Free Today',
    'signup.descriptionGold1': '14-day free trial.',
    'signup.descriptionGold2': 'Zero credit card required.',
    'signup.descriptionEnd': 'Full access to all features.',
    'signup.trialBenefitsTitle': 'Start Your Free Trial',
    'signup.trialBenefitsDesc': 'Experience the full power of Alnajah ERP with zero commitment.',
    'signup.benefit1': '14-Day Free Trial',
    'signup.benefit2': 'No Credit Card Required',
    'signup.benefit3': 'Instant Access After Email Verification',
    'signup.benefit4': 'Full Access to Your Selected Plan',
    'signup.benefit5': 'Enterprise-Grade Security',
    'signup.benefit6': 'Cancel Anytime',
    'signup.trustedBy': 'Trusted by',
    'signup.enterpriseClients': '500+ enterprise clients',
    'signup.acrossMENA': 'across MENA',
    'signup.companyName': 'Company Name',
    'signup.companySize': 'Company Size',
    'signup.country': 'Country',
    'signup.stateProvince': 'State / Province',
    'signup.city': 'City',
    'signup.contactPersonName': 'Contact Person Name',
    'signup.businessEmail': 'Business Email',
    'signup.phoneNumber': 'Phone Number',
    'signup.selectCountry': 'Select country',
    'signup.selectCompanySize': 'Select company size',
    'signup.createFreeAccount': 'Create Free Account',
    'signup.footerText': 'Start your 14-day free trial. No credit card required.',
    'signup.verifyEmail': 'Verify Your Email',
    'signup.verifyEmailSent': 'We\'ve sent a 5-character verification code to:',
    'signup.verificationCode': 'Verification Code',
    'signup.invalidCode': 'Invalid code. Please try again.',
    'signup.expiredCode': 'Code expired. Please request a new one.',
    'signup.resendCodeIn': 'Resend code in {seconds} seconds',
    'signup.resendCode': 'Resend Code',
    'signup.verifyButton': 'Verify Email',
    'signup.verifying': 'Verifying...',
    'signup.emailVerified': 'Email Verified!',
    'signup.accountCreated': 'Your account has been created successfully. Welcome to Alnajah ERP!',
    'signup.companyNameRequired': 'Company name is required',
    'signup.companySizeRequired': 'Company size is required',
    'signup.countryRequired': 'Country is required',
    'signup.stateRequired': 'State/Province is required',
    'signup.cityRequired': 'City is required',
    'signup.contactNameRequired': 'Contact name is required',
    'signup.emailInvalid': 'Please enter a valid business email',
    'signup.emailExists': 'An account with this email already exists.',
    'signup.emailExistsLogin': 'Log in instead',
    'signup.phoneRequired': 'Phone number is required',
    'signup.cancelButton': 'Cancel',
    'signup.1-10': '1-10 employees',
    'signup.11-50': '11-50 employees',
    'signup.51-200': '51-200 employees',
    'signup.201-500': '201-500 employees',
    'signup.501-1000': '501-1,000 employees',
    'signup.1000Plus': '1,000+ employees',
    'signup.placeholderCompany': 'Acme Corporation',
    'signup.placeholderCity': 'e.g., Jeddah',
    'signup.placeholderState': 'e.g., Riyadh',
    'signup.placeholderContact': 'John Doe',
    'signup.placeholderPhone': '6789 2345 1 966+',
    'signup.placeholderEmail': 'you@company.com',

    // Verification
    'verify.title': 'Verify Your Email',
    'verify.description': 'We\'ve sent a verification code to your email. Enter it below to confirm.',
    'verify.code': 'Code',
    'verify.submit': 'Verify',
    'verify.resend': 'Resend Code',
    'verify.resendWait': 'Resend in {seconds}s',
    'verify.invalidCode': 'Invalid code. Please try again.',
    'verify.expiredCode': 'Code expired. Request a new one.',
    'verify.success': 'Email verified! Welcome to Alnajah.',

    // Footer
    'footer.company': 'Company',
    'footer.about': 'About',
    'footer.careers': 'Careers',
    'footer.blog': 'Blog',
    'footer.product': 'Product',
    'footer.features': 'Features',
    'footer.pricing': 'Pricing',
    'footer.integrations': 'Integrations',
    'footer.support': 'Support',
    'footer.docs': 'Documentation',
    'footer.contact': 'Contact',
    'footer.legal': 'Legal',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.copyright': '© 2025 Ajnihat Alnajah. All rights reserved.',
    'footer.ctaHeading': 'Ready to simplify your operations?',
    'footer.ctaDescription': 'Start your 14-day free trial. No credit card required.',

    // Trusted Section
    'trusted.heading': 'Trusted by Leading Organizations',

    // Features
    'features.heading': 'Everything you need, nothing you don\'t',
    'features.subheading': 'Modular by design. Deploy only the capabilities your business needs today, and expand as you grow — without switching platforms',
    'features.platformModules': 'Platform Modules',
    'features.projects': 'PROJECTS',
    'features.projectsTitle': 'Project Management',
    'features.projectsDesc': 'Plan, execute, and track projects with Gantt charts, task boards, resource allocation, and milestone tracking',
    'features.finance': 'FINANCE',
    'features.financeTitle': 'Finance & Accounting',
    'features.financeDesc': 'Real-time P&L, automated invoicing, expense tracking, and multi-currency support built for MENA compliance',
    'features.people': 'PEOPLE',
    'features.peopleTitle': 'Human Resources',
    'features.peopleDesc': 'Recruitment, payroll, attendance, and performance — fully integrated in a single HRMS suite built for modern teams',
    'features.sales': 'SALES',
    'features.salesTitle': 'CRM & Sales',
    'features.salesDesc': 'Manage leads, deals, and pipelines. Track every interaction and forecast revenue with full pipeline visibility',
    'features.admin': 'ADMIN',
    'features.adminTitle': 'Administration',
    'features.adminDesc': 'Role-based permissions, audit logs, SSO, compliance reporting, and full tenant control from a single admin panel',
    'features.support': 'SUPPORT',
    'features.supportTitle': 'Help Desk',
    'features.supportDesc': 'SLA-driven ticket management, intelligent escalation rules, and omnichannel support inbox in one place',
    'features.intelligence': 'INTELLIGENCE',
    'features.intelligenceTitle': 'Analytics & BI',
    'features.intelligenceDesc': 'Custom dashboards, KPI tracking, and one-click data exports. Turn raw operational data into actionable decisions',
    'features.supplyChain': 'SUPPLY CHAIN',
    'features.supplyChainTitle': 'Inventory & Warehouse',
    'features.supplyChainDesc': 'Real-time stock levels, purchase orders, supplier management, and multi-warehouse support across all locations',

    // Platform Overview
    'platform.badge': 'Platform Overview',
    'platform.heading': 'One unified platform. Every module connected',
    'platform.description': 'Alnajah ERP is built on a shared data layer. Every module speaks the same language — so your teams stay aligned, your data stays consistent, and your decisions stay sharp',
    'platform.architecture': 'Platform Architecture',
    'platform.ecosystem': 'Alnajah ERP — Module Ecosystem',
    'platform.allSystemsLive': 'All systems live',
    'platform.coreServices': 'Core Platform Services',
    'platform.ssoRbac': 'SSO & RBAC',
    'platform.restApi': 'REST & Webhook API',
    'platform.workflowEngine': 'Workflow Engine',
    'platform.dataLayer': 'Unified Data Layer',
    'platform.modules': 'Application Modules — Click to Inspect',
    'platform.moduleInstructions': 'Click any module above to view integration details and data flows',
    'platform.integrations': 'External Integrations & Channels',
    'platform.feature1': 'Role-based permissions and access control',
    'platform.feature2': 'Single sign-on across all modules',
    'platform.feature3': 'Arabic & English bilingual interface',
    'platform.feature4': 'Real-time notifications and activity feeds',
    'platform.feature5': 'REST API and webhooks for integrations',
    'platform.feature6': 'Mobile-responsive web app',
    'platform.feature7': 'Audit logs and compliance reporting',
    'platform.feature8': 'Automated workflows and triggers',
    'platform.demo': 'Request a Demo',

    // Pricing
    'pricing.badge': 'Pricing',
    'pricing.heading': 'Plan Comparison',
    'pricing.subheading': 'No hidden fees. Cancel anytime. Every plan includes a 14-day free trial',
    'pricing.save20': 'Save 20%',
    'pricing.annual': 'Annual',
    'pricing.monthly': 'Monthly',
    'pricing.starter': 'Starter',
    'pricing.starterDesc': 'For small teams hitting the ground running',
    'pricing.professional': 'Professional',
    'pricing.professionalDesc': 'For scaling teams that need the full platform',
    'pricing.enterprise': 'Enterprise',
    'pricing.enterpriseDesc': 'Tailored for large, complex organisations',
    'pricing.custom': 'Custom',
    'pricing.price49': '$49',
    'pricing.price149': '$149',
    'pricing.perUserMonth': 'per user / mo',
    'pricing.unlimited': 'Unlimited',
    'pricing.upTo10': 'Up to 10 users',
    'pricing.upTo100': 'Up to 100 users',
    'pricing.unlimitedUsers': 'Unlimited users',
    'pricing.allModulesIncluded': 'All modules included',
    'pricing.allStarterModules': 'All Starter modules',
    'pricing.unlimitedStorage': 'Unlimited storage',
    'pricing.storage5GB': 'GB storage 5',
    'pricing.storage50GB': 'GB storage 50',
    'pricing.crmAndSalesModule': 'CRM & Sales module',
    'pricing.financeBasic': 'Finance (basic)',
    'pricing.hrPayroll': 'HR & Payroll',
    'pricing.projectManagement': 'Project Management',
    'pricing.inventoryWarehouse': 'Inventory & Warehouse',
    'pricing.customIntegrations': 'Custom integrations',
    'pricing.auditLogs': 'Audit logs',
    'pricing.customBranding': 'Custom branding',
    'pricing.fullDataExport': 'Full data export',
    'pricing.dedicatedOnboarding': 'Dedicated onboarding',
    'pricing.onPremiseOption': 'On-premise option',
    'pricing.emailSupport': 'Email Support',
    'pricing.sla247': 'SLA 24/7 support',
    'pricing.fullApiAccess': 'Full API access',
    'pricing.advancedReports': 'Advanced reports & BI',
    'pricing.automationWorkflows': 'Automation workflows',
    'pricing.prioritySupport': 'Priority support',
    'pricing.apiReadAccess': 'API read access',
    'pricing.standardReports': 'Standard reports',
    'pricing.sso': 'SSO',
    'pricing.saml': 'SSO + SAML',
    'pricing.mfa': 'MFA',
    'pricing.startFreeTrial': 'Start Free Trial',
    'pricing.contactSales': 'Contact Sales',
    'pricing.mostPopular': 'Most Popular',
    'pricing.starterPrice': 'from $39/mo',
    'pricing.professionalPrice': 'from $119/mo',
    'pricing.enterprisePrice': 'Custom pricing',
    'comparison.feature': 'Feature',
    'pricing.footer': 'All plans include 14-day free trial. No credit card required.',
    'pricing.compareFeatures': 'Compare all features',
    'pricing.billedAnnually': 'billed annually',

    // Testimonials
    'testimonials.badge': 'Testimonials',
    'testimonials.heading': 'Loved by teams across the region',
    'testimonials.subheading': 'Hear from the operations leaders, CFOs, and HR managers who run their business on Alnajah ERP every day',
    'testimonials.quote1': 'The unified dashboard gives me a real-time view of our entire operation. I can make decisions in minutes that used to take days of spreadsheet wrangling',
    'testimonials.name1': 'Lina Saad',
    'testimonials.title1': 'Operations Director',
    'testimonials.company1': 'Nile Ventures',
    'testimonials.quote2': 'Alnajah ERP transformed how we manage our 300-person workforce. The HR and Finance modules alone saved us 40 hours a month — and our finance team finally trusts the numbers',
    'testimonials.name2': 'Khalid Al-Rashidi',
    'testimonials.title2': 'CEO',
    'testimonials.company2': 'Gulf Horizon Group',
    'testimonials.quote3': 'Onboarding was smooth and the support team is always responsive. Our team adopted the platform in under a week — the bilingual UI made all the difference',
    'testimonials.name3': 'Reem Al-Farsi',
    'testimonials.title3': 'HR Manager',
    'testimonials.company3': 'Qamar Holdings',
    'testimonials.quote4': 'The multi-currency finance module handles our cross-border transactions flawlessly. The audit trail and compliance exports made our external audit 60% faster',
    'testimonials.name4': 'Omar Hamdan',
    'testimonials.title4': 'CFO',
    'testimonials.company4': 'Emirates Capital',
    'testimonials.categoryLeader': 'category leader 2024',
    'testimonials.reviews': 'reviews',
    'testimonials.rating': 'rating',

    // Plan Comparison
    'comparison.heading': 'Everything you need, nothing you don\'t',
    'comparison.subheading': 'A full feature breakdown across every plan so you can make the right decision for your team',
    'comparison.platformLimits': 'Platform Limits',
    'comparison.users': 'Users',
    'comparison.usersDetail': 'Named user seats included',
    'comparison.storage': 'Storage',
    'comparison.storageDetail': 'File attachments and document storage',
    'comparison.integration': 'Integration & Automation',
    'comparison.apiAccess': 'API Access',
    'comparison.apiAccessDetail': 'REST + webhook API availability',
    'comparison.automation': 'Automation',
    'comparison.automationDetail': 'Trigger-based workflow automation rules',
    'comparison.customIntegrations': 'Custom Integrations',
    'comparison.customIntegrationsDetail': 'Bespoke third-party connectors',
    'comparison.reporting': 'Reporting & Analytics',
    'comparison.reports': 'Reports',
    'comparison.reportsDetail': 'Built-in report templates',
    'comparison.auditLogs': 'Audit Logs',
    'comparison.auditLogsDetail': 'Full activity audit trail with export',
    'comparison.dataExport': 'Data Export',
    'comparison.dataExportDetail': 'Export data to CSV, Excel, or via API',
    'comparison.security': 'Security & Identity',
    'comparison.sso': 'SSO',
    'comparison.ssoDetail': 'Single Sign-On via SAML 2.0 / OIDC',
    'comparison.mfa': 'MFA',
    'comparison.mfaDetail': 'Multi-factor authentication enforcement',
    'comparison.customBranding': 'Custom Branding',
    'comparison.customBrandingDetail': 'White-label portal with your logo and domain',
    'comparison.support': 'Support',
    'comparison.prioritySupport': 'Priority Support',
    'comparison.prioritySupportDetail': 'Faster SLA response guarantees',
    'comparison.dedicatedOnboarding': 'Dedicated Onboarding',
    'comparison.dedicatedOnboardingDetail': 'Assigned implementation specialist',
    'comparison.supportChannel': 'Support Channel',
    'comparison.supportChannelDetail': 'Primary support access method',
    'comparison.unlimited': 'Unlimited',
    'comparison.readOnly': 'Read-only',
    'comparison.full': 'Full',
    'comparison.rules50': '50 rules',
    'comparison.rulesUnlimited': 'Unlimited',
    'comparison.standard': 'Standard',
    'comparison.advanced': 'Advanced',
    'comparison.customBI': 'Custom + BI',
    'comparison.days30': '30 days',
    'comparison.csv': 'CSV',
    'comparison.csvExcel': 'CSV + Excel',
    'comparison.allFormats': 'All formats',
    'comparison.ssoPlusSaml': 'SSO + SAML',
    'comparison.emailPhone': 'Email + Phone',
    'comparison.ready': 'Ready to get started?',

    // FAQ
    'faq.heading': 'Frequently Asked Questions',
    'faq.intro': 'Everything you need to know about Alnajah ERP. Can\'t find the answer you\'re looking for?',
    'faq.introLink': 'Contact our team',
    'faq.faq1': 'How long does implementation typically take?',
    'faq.faq1Ans': 'Most implementations are completed within 4-8 weeks, depending on your organization size and complexity.',
    'faq.faq2': 'Can you integrate with our existing systems?',
    'faq.faq2Ans': 'Yes, we offer comprehensive integrations with popular ERP, CRM, and accounting systems.',
    'faq.faq3': 'Is there a free trial available?',
    'faq.faq3Ans': 'Absolutely! You get 14 days free access to all features without requiring a credit card.',
    'faq.faq4': 'What kind of support do you provide?',
    'faq.faq4Ans': 'We offer 24/7 email and phone support, plus dedicated success managers for enterprise clients.',
    'faq.ctaHeading': 'Still have questions?',
    'faq.ctaDescription': 'Our solutions team is available via chat, email, and phone — typically within 2 hours on business days.',
    'faq.ctaButton': 'Talk to sales',

    // Dashboard
    'dashboard.revenue': 'Revenue',
    'dashboard.pipeline': 'Pipeline',
    'dashboard.customers': 'Customers',
    'dashboard.churn': 'Churn',
    'dashboard.salesPipeline': 'Sales Pipeline',
    'dashboard.q2_2025': 'Q2 2025',
    'dashboard.prospecting': 'Prospecting',
    'dashboard.qualification': 'Qualification',
    'dashboard.proposal': 'Proposal',
    'dashboard.negotiation': 'Negotiation',
    'dashboard.closedWon': 'Closed Won',
    'dashboard.quickStats': 'Quick Stats',
    'dashboard.openTickets': 'Open Tickets',
    'dashboard.activeTasks': 'Active Tasks',
    'dashboard.teamMembers': 'Team Members',
    'dashboard.meetingsToday': 'Meetings Today',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.activity1': 'Deal "Gulf Petrochemicals" moved to Proposal',
    'dashboard.activity2': 'Invoice #INV-2841 sent to Al Rajhi Group',
    'dashboard.activity3': '3 new leads from LinkedIn campaign',
    'dashboard.activity4': 'Payroll run completed — 47 employees',
    'dashboard.systemHealth': 'System Health',
    'dashboard.storage': 'Storage',
    'dashboard.api': 'API',
    'dashboard.uptime': 'Uptime',
    'dashboard.response': 'Response',

    // Errors
    'error.required': 'This field is required',
    'error.invalidEmail': 'Please enter a valid email',
    'error.invalidPhone': 'Please enter a valid phone number',
  },
  ar: {
    // Navigation
    'nav.platform': 'المنصة',
    'nav.pricing': 'الأسعار',
    'nav.testimonials': 'آراء العملاء',
    'nav.faq': 'الأسئلة الشائعة',
    'nav.login': 'دخول',
    'nav.getStarted': 'ابدأ مجاناً',

    // Hero
    'hero.badge': 'منصة ERP للمؤسسات',
    'hero.headline': 'عملك بالكامل.',
    'hero.headlineGold': 'منصة واحدة.',
    'hero.description': 'برنامج مؤسسي مصمم لتوحيد عملك. من علاقات العملاء والتمويل والعمليات وما بعده - كل ذلك على منصة ذكية واحدة.',
    'hero.cta': 'ابدأ التجربة المجانية',
    'hero.demoLink': 'شاهد العرض التوضيحي',
    'hero.trust1': 'معتمد SOC 2 Type II',
    'hero.trust2': '4.9 / 5 على G2',
    'hero.trust3': '500+ عميل مؤسسي',
    'hero.stat1': '12',
    'hero.stat1Label': 'وحدات ERP',
    'hero.stat2': '99.9%',
    'hero.stat2Label': 'اتفاقية مستوى الخدمة',
    'hero.stat3': '24/7',
    'hero.stat3Label': 'الدعم',
    'hero.stat4': '<48h',
    'hero.stat4Label': 'الإعداد',

    // Signup
    'signup.badge': 'ابدأ الآن',
    'signup.headline': 'هل أنت مستعد لتحويل عملك؟',
    'signup.headlineGold': 'ابدأ مجاناً اليوم',
    'signup.descriptionGold1': 'تجربة مجانية لمدة 14 يوماً.',
    'signup.descriptionGold2': 'بدون بطاقة ائتمان.',
    'signup.descriptionEnd': 'الوصول الكامل لجميع الميزات.',
    'signup.trialBenefitsTitle': 'ابدأ نسختك التجريبية المجانية',
    'signup.trialBenefitsDesc': 'اختبر القوة الكاملة لـ Alnajah ERP بدون التزام.',
    'signup.benefit1': 'تجربة مجانية لمدة 14 يوماً',
    'signup.benefit2': 'بدون بطاقة ائتمان مطلوبة',
    'signup.benefit3': 'الوصول الفوري بعد تحقق البريد الإلكتروني',
    'signup.benefit4': 'الوصول الكامل لخطتك المختارة',
    'signup.benefit5': 'أمان بمستوى المؤسسات',
    'signup.benefit6': 'ألغِ في أي وقت',
    'signup.trustedBy': 'موثوق به من قبل',
    'signup.enterpriseClients': '500+ عميل مؤسسي',
    'signup.acrossMENA': 'عبر منطقة الشرق الأوسط وشمال أفريقيا',
    'signup.companyName': 'اسم الشركة',
    'signup.companySize': 'حجم الشركة',
    'signup.country': 'الدولة',
    'signup.stateProvince': 'الولاية / المحافظة',
    'signup.city': 'المدينة',
    'signup.contactPersonName': 'اسم جهة الاتصال',
    'signup.businessEmail': 'البريد الإلكتروني للعمل',
    'signup.phoneNumber': 'رقم الهاتف',
    'signup.selectCountry': 'اختر الدولة',
    'signup.selectCompanySize': 'اختر حجم الشركة',
    'signup.createFreeAccount': 'إنشاء حساب مجاني',
    'signup.footerText': 'ابدأ نسختك التجريبية لمدة 14 يوماً. بدون بطاقة ائتمان مطلوبة.',
    'signup.verifyEmail': 'تحقق من بريدك الإلكتروني',
    'signup.verifyEmailSent': 'لقد أرسلنا رمز تحقق من 5 أحرف إلى:',
    'signup.verificationCode': 'رمز التحقق',
    'signup.invalidCode': 'رمز غير صحيح. يرجى المحاولة مرة أخرى.',
    'signup.expiredCode': 'انتهت صلاحية الرمز. يرجى طلب رمز جديد.',
    'signup.resendCodeIn': 'إعادة إرسال الرمز في {seconds} ثانية',
    'signup.resendCode': 'إعادة إرسال الرمز',
    'signup.verifyButton': 'تحقق من البريد الإلكتروني',
    'signup.verifying': 'جاري التحقق...',
    'signup.emailVerified': 'تم التحقق من البريد الإلكتروني!',
    'signup.accountCreated': 'تم إنشاء حسابك بنجاح. أهلاً بك في Alnajah ERP!',
    'signup.companyNameRequired': 'اسم الشركة مطلوب',
    'signup.companySizeRequired': 'حجم الشركة مطلوب',
    'signup.countryRequired': 'الدولة مطلوبة',
    'signup.stateRequired': 'الولاية/المحافظة مطلوبة',
    'signup.cityRequired': 'المدينة مطلوبة',
    'signup.contactNameRequired': 'اسم جهة الاتصال مطلوب',
    'signup.emailInvalid': 'يرجى إدخال بريد إلكتروني للعمل صحيح',
    'signup.emailExists': 'يوجد حساب مسجل بهذا البريد الإلكتروني بالفعل.',
    'signup.emailExistsLogin': 'تسجيل الدخول بدلاً من ذلك',
    'signup.phoneRequired': 'رقم الهاتف مطلوب',
    'signup.cancelButton': 'إلغاء',
    'signup.1-10': '1-10 موظفين',
    'signup.11-50': '11-50 موظفين',
    'signup.51-200': '51-200 موظف',
    'signup.201-500': '201-500 موظف',
    'signup.501-1000': '501-1,000 مو��ف',
    'signup.1000Plus': '1,000+ موظف',
    'signup.placeholderCompany': 'شركة أكمي',
    'signup.placeholderCity': 'مثال: جدة',
    'signup.placeholderState': 'مثال: الرياض',
    'signup.placeholderContact': 'أحمد محمد',
    'signup.placeholderPhone': '6789 2345 1 966+',
    'signup.placeholderEmail': 'you@company.com',

    // Verification
    'verify.title': 'تحقق من بريدك الإلكتروني',
    'verify.description': 'أرسلنا رمز تحقق إلى بريدك الإلكتروني. أدخله أدناه للتأكيد.',
    'verify.code': 'الرمز',
    'verify.submit': 'تحقق',
    'verify.resend': 'إعادة إرسال الرمز',
    'verify.resendWait': 'إعادة إرسال في {seconds}ث',
    'verify.invalidCode': 'رمز غير صحيح. يرجى المحاولة مرة أخرى.',
    'verify.expiredCode': 'انتهت صلاحية الرمز. اطلب واحداً جديداً.',
    'verify.success': 'تم التحقق من البريد الإلكتروني! مرحباً بك في Alnajah.',

    // Footer
    'footer.company': 'الشركة',
    'footer.about': 'عن الشركة',
    'footer.careers': 'الوظائف',
    'footer.blog': 'المدونة',
    'footer.product': 'المنتج',
    'footer.features': 'الميزات',
    'footer.pricing': 'الأسعار',
    'footer.integrations': 'التكاملات',
    'footer.support': 'الدعم',
    'footer.docs': 'التوثيق',
    'footer.contact': 'اتصل بنا',
    'footer.legal': 'قانوني',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.terms': 'شروط الخدمة',
    'footer.copyright': '© 2025 Ajnihat Alnajah. جميع الحقوق محفوظة.',
    'footer.ctaHeading': 'هل أنت مستعد لتبسيط عملياتك؟',
    'footer.ctaDescription': 'ابدأ نسختك التجريبية المجانية لمدة 14 يوماً. بدون بطاقة ائتمان مطلوبة.',

    // Trusted Section
    'trusted.heading': 'موثوق به من قبل المنظمات الرائدة',

    // Features
    'features.heading': 'كل ما تحتاجه، بدون ما لا تحتاجه',
    'features.subheading': 'تصميم معياري. قم بنشر القدرات التي تحتاجها عملك اليوم فقط، وتوسع حسب نموك - بدون تغيير المنصات',
    'features.platformModules': 'وحدات المنصة',
    'features.projects': 'المشاريع',
    'features.projectsTitle': 'إدارة المشاريع',
    'features.projectsDesc': 'خطط وقم بتنفيذ وتتبع المشاريع باستخدام مخططات جانت وألواح المهام وتخصيص الموارد وتتبع الأحداث الرئيسية',
    'features.finance': 'المالية',
    'features.financeTitle': 'المالية والمحاسبة',
    'features.financeDesc': 'بيان الدخل والخسارة في الوقت الفعلي والفواتير الآلية وتتبع النفقات وا دعم العملات المتعددة المدمج لتوافق MENA',
    'features.people': 'الأشخاص',
    'features.peopleTitle': 'الموارد البشرية',
    'features.peopleDesc': 'التوظيف والرواتب والحضور والأداء - متكاملة بالكامل في مجموعة HRMS واحدة مبنية للفرق الحديثة',
    'features.sales': 'المبيعات',
    'features.salesTitle': 'إدارة العلاقات والمبيعات',
    'features.salesDesc': 'إدارة العملاء المحتملين والصفقات والخطوط. تتبع كل تفاعل وتنبؤ بالإيرادات مع رؤية خط مبيعات كاملة',
    'features.admin': 'الإدارة',
    'features.adminTitle': 'الإدارة',
    'features.adminDesc': 'الأذونات المستندة إلى الأدوار وسجلات التدقيق والمصادقة ذات العامل الواحد والامتثال لمتطلبات التقارير والتحكم الكامل من لوحة إدارة واحدة',
    'features.support': 'الدعم',
    'features.supportTitle': 'مكتب المساعدة',
    'features.supportDesc': 'إدارة التذاكر المدفو��ة بـ SLA وقواعد التصعيد الذكية وصندوق دعم متعدد القنوات في مكان واحد',
    'features.intelligence': 'الذكاء',
    'features.intelligenceTitle': 'التحليلات والذكاء',
    'features.intelligenceDesc': 'لوحات معلومات مخصصة وتتبع مؤشرات الأداء الرئيسية وتصدير البيانات بنقرة واحدة. حول البيانات التشغيلية إلى قرارات قابلة للتنفيذ',
    'features.supplyChain': 'سلسلة التوريد',
    'features.supplyChainTitle': 'المخزون والمستودع',
    'features.supplyChainDesc': 'مستويات المخزون في الوقت الفعلي وأوامر الشراء وإدارة الموردين ودعم متعدد المستودعات عبر جميع المواقع',

    // Platform Overview
    'platform.badge': 'نظرة عامة على المنصة',
    'platform.heading': 'منصة موحدة واحدة. كل وحدة متصلة',
    'platform.description': 'تم بناء Alnajah ERP على طبقة بيانات مشتركة. تتحدث كل وحدة نفس اللغة - حتى تبقى فريقك متوافقاً وبيانات مشاركتك متسقة وقراراتك حادة',
    'platform.architecture': 'معمارية المنصة',
    'platform.ecosystem': 'Alnajah ERP — نظام الوحدات البيئي',
    'platform.allSystemsLive': 'جميع الأنظمة نشطة',
    'platform.coreServices': 'خدمات المنصة الأساسية',
    'platform.ssoRbac': 'الدخول الموحد والتحكم بالأدوار',
    'platform.restApi': 'REST و Webhook API',
    'platform.workflowEngine': 'محرك سير العمل',
    'platform.dataLayer': 'طبقة البيانات الموحدة',
    'platform.modules': 'وحدات التطبيق - انقر للفحص',
    'platform.moduleInstructions': 'انقر فوق أي وحدة أعلاه لعرض تفاصيل التكامل وتدفقات البيانات',
    'platform.integrations': 'التكاملات الخارجية والقنوات',
    'platform.feature1': 'الأذونات المستندة إلى الأدوار والتحكم بالوصول',
    'platform.feature2': 'الدخول الموحد عبر جميع الوحدات',
    'platform.feature3': 'واجهة ثنائية اللغة بالعربية والإنجليزية',
    'platform.feature4': 'الإخطارات في الوقت الفعلي وخلاصات النشاط',
    'platform.feature5': 'واجهة ب��مجية REST و webhooks للتكاملات',
    'platform.feature6': 'تطبيق ويب سريع الاستجابة للأجهزة المحمولة',
    'platform.feature7': 'سجلات التدقيق وتقارير الامتثال',
    'platform.feature8': 'سير العمل التلقائي والمحفزات',
    'platform.demo': 'اطلب عرض توضيحي',

    // Pricing
    'pricing.badge': 'الأسعار',
    'pricing.heading': 'مقارنة الخطط',
    'pricing.subheading': 'بدون رسوم مخفية. ألغِ في أي وقت. تتضمن جميع الخطط نسخة تجريبية مجانية لمدة 14 يوماً',
    'pricing.save20': 'وفر 20%',
    'pricing.annual': 'سنوي',
    'pricing.monthly': 'شهري',
    'pricing.starter': 'المبتدئ',
    'pricing.starterDesc': 'للفرق الصغيرة التي تبدأ للتو',
    'pricing.professional': 'احترافي',
    'pricing.professionalDesc': 'للفرق المتنامية التي تحتاج إلى المنصة الكاملة',
    'pricing.enterprise': 'مؤسسي',
    'pricing.enterpriseDesc': 'مخصص ل��منظمات الكبيرة والمعقدة',
    'pricing.custom': 'مخصص',
    'pricing.price49': '$49',
    'pricing.price149': '$149',
    'pricing.perUserMonth': 'لكل مستخدم / شهر',
    'pricing.unlimited': 'غير محدود',
    'pricing.upTo10': 'حتى 10 مستخدمين',
    'pricing.upTo100': 'حتى 100 مستخدم',
    'pricing.unlimitedUsers': 'مستخدمون غير محدودين',
    'pricing.allModulesIncluded': 'جميع الوحدات ��درجة',
    'pricing.allStarterModules': 'جميع وحدات المبتدئ',
    'pricing.unlimitedStorage': 'تخزين غير محدود',
    'pricing.storage5GB': 'تخزين 5 جيجابايت',
    'pricing.storage50GB': 'تخزين 50 جيجابايت',
    'pricing.crmAndSalesModule': 'وحدة CRM والمبيعات',
    'pricing.financeBasic': 'الما��ية (الأساسية)',
    'pricing.hrPayroll': 'الموارد البشرية والرواتب',
    'pricing.projectManagement': 'إدارة المشاريع',
    'pricing.inventoryWarehouse': 'المخزون والمستودع',
    'pricing.customIntegrations': 'تكاملات مخصصة',
    'pricing.auditLogs': 'سجلات التدقيق',
    'pricing.customBranding': 'ا��علامات المخصصة',
    'pricing.fullDataExport': 'تصدير البيا��ات الكامل',
    'pricing.dedicatedOnboarding': 'إعداد مخصص',
    'pricing.onPremiseOption': 'خيار الخادم المحلي',
    'pricing.emailSupport': 'دعم البريد الإلكتروني',
    'pricing.sla247': 'دعم SLA 24/7',
    'pricing.fullApiAccess': 'الوصول الكامل إلى واجهة برمجية',
    'pricing.advancedReports': 'التقارير والذكاء المتقدم',
    'pricing.automationWorkflows': 'سير العمل التلقائي',
    'pricing.prioritySupport': 'الدعم الأولوي',
    'pricing.apiReadAccess': 'وصول قراءة واجهة برمجية',
    'pricing.standardReports': 'التقارير القياسية',
    'pricing.sso': 'الدخول الموحد',
    'pricing.saml': 'الدخول الموحد + SAML',
    'pricing.mfa': 'المصادقة متعددة العوامل',
    'pricing.startFreeTrial': 'ابدأ التجربة المجانية',
    'pricing.contactSales': 'تواصل مع فريق المبيعات',
    'pricing.mostPopular': 'الأكثر شهرة',
    'pricing.starterPrice': 'من $39/شهر',
    'pricing.professionalPrice': 'من $119/شهر',
    'pricing.enterprisePrice': 'تسعير مخصص',
    'comparison.feature': 'ميزة',
    'pricing.footer': 'تتضمن جميع الخطط نسخة تجريبية مجانية لمدة 14 يوماً. بدون بطاقة ائتمان مطلوبة.',
    'pricing.compareFeatures': 'قارن جميع الميزات',
    'pricing.billedAnnually': 'يتم الفوترة سنوياً',

    // Testimonials
    'testimonials.badge': 'آراء العملاء',
    'testimonials.heading': 'محبوب من قبل فرق في جميع أنحاء المنطقة',
    'testimonials.subheading': 'اسمع من قادة العمليات والمديرين الماليين ومديري الموارد البشرية الذين يدير عملهم على Alnajah ERP كل يوم',
    'testimonials.quote1': 'لوحة التحكم الموحدة تعطيني عرضاً في الوقت الفعلي لعملياتنا بأكملها. يمكنني اتخاذ قرارات في دقائق كانت تستغرق أياماً من التعامل مع جداول البيانات',
    'testimonials.name1': 'لينا سعد',
    'testimonials.title1': 'مدير العمليات',
    'testimonials.company1': 'نايل فينتشرز',
    'testimonials.quote2': 'غيّرت Alnajah ERP الطريقة التي نإدير بها قوتنا العاملة من 300 شخص. وحدات الموارد البشرية والمالية وحدها وفّرت لنا 40 ساعة في الشهر — وفريق المالية يثق أخيراً بالأرقام',
    'testimonials.name2': 'خالد الراشدي',
    'testimonials.title2': 'الرئيس التنفيذي',
    'testimonials.company2': 'مجموعة جولف هوريزون',
    'testimonials.quote3': 'كان الإعداد سلساً وفريق الدعم دائماً متجاوب. اعتمد فريقنا على المنصة في أقل من أسبوع — واجهة المستخدم ثنائية اللغة أحدثت كل الفرق',
    'testimonials.name3': 'ريم الفارسي',
    'testimonials.title3': 'مدير الموارد البشرية',
    'testimonials.company3': 'مجموعة قمر',
    'testimonials.quote4': 'وحدة التمويل متعددة العملات تتعامل مع معاملاتنا عبر الحدود بسلاسة. سجل التدقيق وتصدير الامتثال جعل تدقيقنا الخارجي أسرع بـ 60٪',
    'testimonials.name4': 'عمر حمدان',
    'testimonials.title4': 'المدير المالي',
    'testimonials.company4': 'رأس المال الإمارات',
    'testimonials.categoryLeader': 'قائد الفئة 2024',
    'testimonials.reviews': 'التقييمات',
    'testimonials.rating': 'التصنيف',

    // Plan Comparison
    'comparison.heading': 'كل ما تحتاجه، بدون ما لا تحتاجه',
    'comparison.subheading': 'تفصيل ميزات كامل عبر كل خطة حتى تتمكن من اتخاذ القرار الصحيح لفريقك',
    'comparison.platformLimits': 'حدود المنصة',
    'comparison.users': 'المستخدمون',
    'comparison.usersDetail': 'مقاعد المستخدمين المسماة المدرجة',
    'comparison.storage': 'التخزين',
    'comparison.storageDetail': 'تخزين المرفقات والمستندات',
    'comparison.integration': 'التكامل والأتمتة',
    'comparison.apiAccess': 'وصول واجهة برمجية',
    'comparison.apiAccessDetail': 'توفر واجهة برمجية REST و webhook',
    'comparison.automation': 'الأتمتة',
    'comparison.automationDetail': 'قواعد أتمتة سير العمل المستندة إلى المحفزات',
    'comparison.customIntegrations': 'تكاملات مخصصة',
    'comparison.customIntegrationsDetail': 'موصلات جهات خارجية مخصصة',
    'comparison.reporting': 'التقارير والتحليلات',
    'comparison.reports': 'التقارير',
    'comparison.reportsDetail': 'قوالب التقارير المدمجة',
    'comparison.auditLogs': 'سجلات التدقيق',
    'comparison.auditLogsDetail': 'سجل نشاط التدقيق الكامل مع التصدير',
    'comparison.dataExport': 'تصدير البيانات',
    'comparison.dataExportDetail': 'تصدير البيانات إلى CSV أو Excel أو عبر واجهة برمجية',
    'comparison.security': 'الأمان والهوية',
    'comparison.sso': 'الدخول الموحد',
    'comparison.ssoDetail': 'الدخول الموحد عبر SAML 2.0 / OIDC',
    'comparison.mfa': 'المصادقة متعددة العوامل',
    'comparison.mfaDetail': 'فرض المصادقة متعددة العوامل',
    'comparison.customBranding': 'العلامات المخصصة',
    'comparison.customBrandingDetail': 'بوابة ذات علامات بيضاء مع شعارك واسم مجال',
    'comparison.support': 'الدعم',
    'comparison.prioritySupport': 'الدعم الأولوي',
    'comparison.prioritySupportDetail': 'ضمانات استجابة SLA أسرع',
    'comparison.dedicatedOnboarding': 'إعداد مخصص',
    'comparison.dedicatedOnboardingDetail': 'متخصص التنفيذ المعين',
    'comparison.supportChannel': 'قناة الدعم',
    'comparison.supportChannelDetail': 'طريقة الوصول إلى الدعم الأساسية',
    'comparison.unlimited': 'غير محدود',
    'comparison.readOnly': 'قراءة فقط',
    'comparison.full': 'كامل',
    'comparison.rules50': '50 قاعدة',
    'comparison.rulesUnlimited': 'غير محدود',
    'comparison.standard': 'قياسي',
    'comparison.advanced': 'متق��م',
    'comparison.customBI': 'مخصص + ذكاء',
    'comparison.days30': '30 يوماً',
    'comparison.csv': 'CSV',
    'comparison.csvExcel': 'CSV + Excel',
    'comparison.allFormats': 'جميع الصيغ',
    'comparison.ssoPlusSaml': 'دخول موحد + SAML',
    'comparison.emailPhone': 'بريد إلكتروني + هاتف',
    'comparison.ready': 'هل أنت مستعد للبدء؟',

    // FAQ
    'faq.heading': 'الأسئلة الشائعة',
    'faq.intro': 'كل ما تحتاج إلى معرفته عن Alnajah ERP. لا تستطيع العثور على الإجابة التي تبحث عنها؟',
    'faq.introLink': 'تواصل معنا',
    'faq.faq1': 'كم من الوقت يستغرق التطبيق عادة؟',
    'faq.faq1Ans': 'يتم إكمال معظم التطبيقات في غضون 4-8 أسابيع، اعتماداً على حجم ومدى تعقيد مؤسستك.',
    'faq.faq2': 'هل يمكنك التكامل مع أنظمتنا الحالية؟',
    'faq.faq2Ans': 'نعم، نحن نقدم تكاملات شاملة مع أنظمة ERP و CRM والمحاسبة الشهيرة.',
    'faq.faq3': 'هل توجد نسخة تجريبية مجانية متاحة؟',
    'faq.faq3Ans': 'بالتأكيد! تحصل على 14 يوماً من الوصول المجاني إلى جميع الميزات بدون الحاجة إلى بطاقة ائتمان.',
    'faq.faq4': 'ما نوع الدعم الذي تقدمونه؟',
    'faq.faq4Ans': 'نحن نقدم دعم بريد إلكتروني وهاتفي 24/7، بالإضافة إلى مديري نجاح مخصصين لعملائنا المؤسسيين.',
    'faq.ctaHeading': 'هل لديك أسئلة أخرى؟',
    'faq.ctaDescription': 'فريق الحلول الخاص بنا متاح عبر الدردشة والبريد الإلكتروني والهاتف — عادة ما يكون في غضون ساعتين في أيام العمل.',
    'faq.ctaButton': 'تحدث مع فريق المبيعات',

    // Dashboard
    'dashboard.revenue': 'الإيرادات',
    'dashboard.pipeline': 'خط الأنابيب',
    'dashboard.customers': 'العملاء',
    'dashboard.churn': 'معدل الفقد',
    'dashboard.salesPipeline': 'خط مبيعات',
    'dashboard.q2_2025': 'Q2 2025',
    'dashboard.prospecting': 'التنقيب',
    'dashboard.qualification': 'التأهيل',
    'dashboard.proposal': 'العرض',
    'dashboard.negotiation': 'التفاوض',
    'dashboard.closedWon': 'مُغلق بنجاح',
    'dashboard.quickStats': 'إحصائيات سريعة',
    'dashboard.openTickets': 'التذاكر المفتوحة',
    'dashboard.activeTasks': 'المهام النشطة',
    'dashboard.teamMembers': 'أعضاء الفريق',
    'dashboard.meetingsToday': 'الاجتماعات اليوم',
    'dashboard.recentActivity': 'الأنشطة الأخيرة',
    'dashboard.activity1': 'تم نقل العرض "Gulf Petrochemicals" إلى المرحلة الثالثة',
    'dashboard.activity2': 'تم إرسال الفاتورة #INV-2841 إلى مجموعة الراجحي',
    'dashboard.activity3': '3 عمل��ء محتملين جدد من حملة LinkedIn',
    'dashboard.activity4': 'تم إكمال الرواتب - 47 موظف',
    'dashboard.systemHealth': 'صحة النظام',
    'dashboard.storage': 'التخزين',
    'dashboard.api': 'API',
    'dashboard.uptime': 'الحد الأدنى للتوفر',
    'dashboard.response': 'الاستجابة',

    // Errors
    'error.required': 'هذا الحقل مطلوب',
    'error.invalidEmail': 'يرجى إدخال بريد إلكتروني صحيح',
    'error.invalidPhone': 'يرجى إدخال رقم هاتف صحيح',
  },
}

export function t(key: string, language: Language, vars?: Record<string, string>): string {
  const text = translations[language][key as keyof typeof translations['en']] || key

  if (vars) {
    let result = text as string
    Object.entries(vars).forEach(([varKey, value]) => {
      result = result.replace(`{${varKey}}`, value)
    })
    return result
  }

  return text as string
}
